import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Card } from './Card'
import { CategoryList } from './Category'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { useCollection } from '../api/collection'
import { Filters } from './Filters'
import { Controls } from './Controls'
import { useMediaQuery } from '~/utils/hooks/useMediaQuery'
import { Overlay } from '~/components/ui/Overlay'
import { useMarketplace } from '../context'
import { useEffect } from 'react'
import { Skeleton } from '~/shared/ui'

function NotFound() {
    const { isFetched } = useCollection()
    if (!isFetched) return null
    return (
        <div className='text-center col-span-full'>
            <h2 className='text-xl font-bold uppercase'>No items found</h2>
            <p className='text-white/50'>Try adjusting your filters or check back later.</p>
        </div>
    )
}

function ItemsGrid() {
    const { data, fetchNextPage, isFetchingNextPage, hasNextPage, isFetched } = useCollection()
    const items = data?.pages.flatMap((page) => page.results) || []

    // The first load used to render an empty grid and then pop the cards in. Skeletons cut at the
    // card's aspect ratio hold the same space, so nothing shifts when the real data lands.
    if (!isFetched) {
        return (
            <div className='flex-1 grid grid-cols-2 sm:grid-cols-[repeat(auto-fill,minmax(220px,min(320px,80vw)))] auto-rows-max items-start justify-center gap-3 sm:gap-4 p-3 sm:p-4'>
                {Array.from({ length: 8 }).map((_, i) => (
                    <Skeleton key={i} className='w-full aspect-square' />
                ))}
            </div>
        )
    }

    return (
        <div className='flex-1 grid grid-cols-2 sm:grid-cols-[repeat(auto-fill,minmax(220px,min(320px,80vw)))] auto-rows-max items-start justify-center gap-3 sm:gap-4 p-3 sm:p-4'>
            {items.map((item) => (
                <Card key={item.id} item={item} />
            ))}
            {hasNextPage && (
                <div
                    className=' col-span-full flex flex-row items-center justify-center gap-4  font-bold cursor-pointer bg-white/5 hover:bg-white/10 border-gradient rounded'
                    onClick={() => fetchNextPage()}
                >
                    <span className='m-2'>LOAD MORE</span>
                    {isFetchingNextPage && <FontAwesomeIcon icon={faSpinner} spin />}
                </div>
            )}
            {items.length === 0 && <NotFound />}
        </div>
    )
}

export function Martketplace() {
    const isMobile = useMediaQuery('(max-width: 768px)')
    const { ui, closeUI } = useMarketplace()

    return (
        <div className='flex flex-col gap-4 relative'>
            <CategoryList />
            <Controls />
            <div className='flex flex-row gap-4'>
                {isMobile ? (
                    <Overlay open={ui.filtersOpen} onClose={() => closeUI('filtersOpen')}>
                        <Filters />
                    </Overlay>
                ) : (
                    <Filters />
                )}
                <ItemsGrid />
            </div>
        </div>
    )
}
